import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import StudioLayerAnimationControls from "./StudioLayerAnimationControls";
import { StyledAdvEditorToolbarFormatGroup } from "../../../styled/details/stylesDetails";
import { ENTER_ANIMATION } from "../../../../_actions/types";
import { updateLayerAnimation } from "../../../../_utils/common";
import { withTranslation } from "react-i18next";
import { setCurrentPlayingAnimation } from "../../../../_actions/animationActions";

export class StudioLayerAnimations extends Component {
  onClick = async (adjustment) => {
    const {
      editor,
      layers,
      pages,
      canvasRef,
      selectedTab,
      setCurrentPlayingAnimation,
    } = this.props;
    // if (adjustment.id === "none") {
    //   canvasRef.handler.removeKey("animation");
    //   return;
    // }
    const currentPageAnimation = pages[editor.activePage.id].payload.animation;
    let defaultDuration = currentPageAnimation["duration"];
    let totalDuration = defaultDuration * 1000;

    const currentPayload = layers[editor.activeElement.id].payload;
    const currentLayerAnimations = currentPayload?.animation;

    const updatedAnimations = updateLayerAnimation(
      totalDuration,
      cloneDeep(currentLayerAnimations),
      adjustment,
      currentPayload,
      selectedTab
    );
    if (adjustment.id === "none") {
      canvasRef.handler.animationHandler.stopAll();
      setCurrentPlayingAnimation(null);
      canvasRef.handler.animationHandler.applyLayerAnimations(
        updatedAnimations
      );
    } else {
      const selectedAnimationIndex = updatedAnimations.findIndex(
        (a) => a.motion === selectedTab
      );

      // Update only if the new animations are different from previous one
      const update = !currentLayerAnimations
        ? true
        : currentLayerAnimations[selectedAnimationIndex]?.parentId !==
          adjustment.id;
      setCurrentPlayingAnimation(
        updatedAnimations.map((item) => item.parentId)
      );
      await canvasRef.handler.animationHandler.previewAndUpdate(
        editor.activeElement,
        updatedAnimations,
        selectedAnimationIndex,
        update,
        defaultDuration
      );
      setCurrentPlayingAnimation(null);
    }
  };

  componentDidMount() {
    const { editor, layers, pages, canvasRef } = this.props;
    const currentPayload = layers[editor.activeElement.id]?.payload;
    const currentLayerAnimations = currentPayload?.animation;

    if (!currentLayerAnimations) {
      const currentPageAnimation =
        pages[editor.activePage.id].payload.animation;

      let defaultDuration = currentPageAnimation["duration"];
      let totalDuration = defaultDuration * 1000;
      const initialAnimations = updateLayerAnimation(
        totalDuration,
        cloneDeep(currentLayerAnimations),
        { id: "none" },
        currentPayload
      );
      canvasRef.handler?.set("animation", initialAnimations);
    }
  }

  getAnimationTypeString(type) {
    let words = type.toLowerCase().split("_");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1);
    }
    return words.join(" ");
  }

  render() {
    const { editor, layers, canvasRef, selectedTab, t } = this.props;
    const currentAnimations =
      layers[editor?.activeElement?.id]?.payload?.animation;
    let selectedAnimationData = null;

    if (currentAnimations) {
      selectedAnimationData = currentAnimations.find(
        (o) => o?.motion === selectedTab
      );
    }

    let selectedAnimationIndex = 0;
    if (currentAnimations) {
      selectedAnimationIndex = currentAnimations.findIndex(
        (a) => a.motion === selectedTab
      );
    }

    return (
      <>
        <StyledAdvEditorToolbarFormatGroup>
          {/*<hr className="tldr-hl mt-12 mb-12" />*/}
          <div>
            <StudioLayerAnimationControls
              animation={selectedAnimationData}
              selectedTab={selectedTab}
              title={selectedTab === ENTER_ANIMATION ? t("enter") : t("exit")}
              // subtitle={this.getAnimationTypeString(animation.type)}
              index={selectedAnimationIndex}
              canvasRef={canvasRef}
              onChangeAnimation={this.onClick}
              allAnimations={currentAnimations}
            />
          </div>
        </StyledAdvEditorToolbarFormatGroup>
      </>
    );
  }
}

StudioLayerAnimations.propTypes = {
  editor: PropTypes.object.isRequired,
  layers: PropTypes.object.isRequired,
  pages: PropTypes.object.isRequired,
  selectedTab: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  layers: state.layerstore.layers,
  pages: state.pagestore.pages,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPlayingAnimation: (payload) =>
    dispatch(setCurrentPlayingAnimation(payload)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(StudioLayerAnimations)
);
